module.exports = __webpack_public_path__ + "static/seedQuality-dbdf421c6b0bf40c5d1d2a22a6d42f1a.png";